var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext, useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { tokens } from '../../constants';
import { StateConfigContext } from '../../providers';
import { announceAccessibility, getTestId } from '../../utils';
import { Button } from '../button';
import { DynamicSvg } from '../dynamic-svg';
import { Typography } from '../typography';
import { Loader } from '../loader';
import { getCalloutProps, getCalloutStyles } from './CalloutStyles';
import { useBreakpoint } from '../../hooks';
export var Callout = forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e;
  var _useState = useState(true),
    showCallout = _useState[0],
    setShowCallout = _useState[1];
  var stateContext = useContext(StateConfigContext);
  var calloutProps = getCalloutProps(props, stateContext);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var calloutStyles = getCalloutStyles(calloutProps);
  var theme = calloutProps.theme,
    style = calloutProps.style,
    title = calloutProps.title,
    _calloutProps$titlePr = calloutProps.titleProps,
    titleProps = _calloutProps$titlePr === void 0 ? {} : _calloutProps$titlePr,
    iconName = calloutProps.iconName,
    isLoading = calloutProps.isLoading,
    state = calloutProps.state,
    iconProps = calloutProps.iconProps,
    description = calloutProps.description,
    _calloutProps$descrip = calloutProps.descriptionProps,
    descriptionProps = _calloutProps$descrip === void 0 ? {} : _calloutProps$descrip,
    ctaText = calloutProps.ctaText,
    ctaProps = calloutProps.ctaProps,
    ctaAccessibilityProps = calloutProps.ctaAccessibilityProps,
    _calloutProps$isCtaDi = calloutProps.isCtaDisabled,
    isCtaDisabled = _calloutProps$isCtaDi === void 0 ? false : _calloutProps$isCtaDi,
    showCrossDismissBtn = calloutProps.showCrossDismissBtn,
    onDismissHandler = calloutProps.onDismissHandler,
    _calloutProps$dismiss = calloutProps.dismissIconName,
    dismissIconName = _calloutProps$dismiss === void 0 ? 'CancelIcon' : _calloutProps$dismiss,
    _calloutProps$hideOnD = calloutProps.hideOnDismiss,
    hideOnDismiss = _calloutProps$hideOnD === void 0 ? true : _calloutProps$hideOnD,
    onCtaPress = calloutProps.onCtaPress,
    config = calloutProps.config,
    _calloutProps$testID = calloutProps.testID,
    testID = _calloutProps$testID === void 0 ? 'Callout' : _calloutProps$testID,
    restProps = __rest(calloutProps, ["theme", "style", "title", "titleProps", "iconName", "isLoading", "state", "iconProps", "description", "descriptionProps", "ctaText", "ctaProps", "ctaAccessibilityProps", "isCtaDisabled", "showCrossDismissBtn", "onDismissHandler", "dismissIconName", "hideOnDismiss", "onCtaPress", "config", "testID"]);
  var calloutState = (_a = config === null || config === void 0 ? void 0 : config.state) === null || _a === void 0 ? void 0 : _a[state];
  var crossDismissIconProps = Object.assign(Object.assign({}, calloutState === null || calloutState === void 0 ? void 0 : calloutState.crossDismissIconProps), {
    width: isLargeScreen ? 28 : (_b = calloutState === null || calloutState === void 0 ? void 0 : calloutState.crossDismissIconProps) === null || _b === void 0 ? void 0 : _b.width,
    height: isLargeScreen ? 28 : (_c = calloutState === null || calloutState === void 0 ? void 0 : calloutState.crossDismissIconProps) === null || _c === void 0 ? void 0 : _c.height
  });
  var calloutTitleColor = calloutState === null || calloutState === void 0 ? void 0 : calloutState.titleColor;
  var calloutIconProps = Object.assign(Object.assign(Object.assign({}, calloutState === null || calloutState === void 0 ? void 0 : calloutState.iconProps), iconProps), {
    width: isLargeScreen ? 28 : (_d = calloutState === null || calloutState === void 0 ? void 0 : calloutState.iconProps) === null || _d === void 0 ? void 0 : _d.width,
    height: isLargeScreen ? 28 : (_e = calloutState === null || calloutState === void 0 ? void 0 : calloutState.iconProps) === null || _e === void 0 ? void 0 : _e.height
  });
  var descriptionColor = calloutState === null || calloutState === void 0 ? void 0 : calloutState.descriptionColor;
  var ctaTheme = calloutState === null || calloutState === void 0 ? void 0 : calloutState.ctaTheme;
  var spacing = tokens.spacing;
  var container = calloutStyles.container,
    iconStyles = calloutStyles.iconStyles,
    calloutContainer = calloutStyles.calloutContainer,
    contentContainer = calloutStyles.contentContainer;
  var hideCallout = () => {
    hideOnDismiss && setShowCallout(false);
    onDismissHandler();
  };
  useEffect(() => {
    if (showCallout) {
      var textsToAnnounce = [title, description, ctaText];
      announceAccessibility(textsToAnnounce);
    }
  }, []);
  return _jsx(_Fragment, {
    children: showCallout && (!!title || !!description) && _jsxs(View, Object.assign({
      ref: ref,
      style: [container, style]
    }, restProps, getTestId(testID), {
      children: [_jsxs(View, Object.assign({
        style: calloutContainer
      }, {
        children: [isLoading ? _jsx(Loader, Object.assign({
          size: "sm",
          color: descriptionColor
        }, getTestId(testID, 'loader'))) : !!iconName && _jsx(DynamicSvg, Object.assign({
          iconName: iconName
        }, calloutIconProps, {
          style: iconStyles
        }, getTestId(testID, iconName))), _jsxs(View, Object.assign({
          style: contentContainer
        }, {
          children: [!!title && _jsx(Typography, Object.assign({
            type: isLargeScreen ? 'body-single-line-md-bold' : 'body-single-line-sm-bold',
            text: title,
            color: calloutTitleColor,
            style: {
              marginBottom: spacing === null || spacing === void 0 ? void 0 : spacing.SPACING_4
            }
          }, titleProps, getTestId(testID, 'title'))), _jsxs(_Fragment, {
            children: [!!description && _jsx(Typography, Object.assign({
              type: isLargeScreen ? 'body-para-sm' : 'body-para-xs',
              text: description,
              color: descriptionColor
            }, descriptionProps, getTestId(testID, 'description'))), !!ctaText && _jsx(Button, Object.assign({
              disabled: isCtaDisabled,
              buttonType: "alternate-" + ctaTheme,
              theme: theme,
              title: ctaText,
              onPress: onCtaPress,
              size: isLargeScreen ? 'md' : 'sm',
              style: {
                marginTop: spacing === null || spacing === void 0 ? void 0 : spacing.SPACING_12
              }
            }, ctaProps, ctaAccessibilityProps, getTestId(testID, 'ctaText')))]
          })]
        }))]
      })), _jsx(View, {
        children: showCrossDismissBtn && _jsx(Pressable, Object.assign({
          accessibilityHint: crossDismissIconProps === null || crossDismissIconProps === void 0 ? void 0 : crossDismissIconProps.accessibilityHint,
          accessibilityRole: crossDismissIconProps === null || crossDismissIconProps === void 0 ? void 0 : crossDismissIconProps.accessibilityRole,
          onPress: hideCallout
        }, {
          children: !!dismissIconName && _jsx(DynamicSvg, Object.assign({
            iconName: dismissIconName
          }, crossDismissIconProps, getTestId(testID, 'cancelIcon')))
        }))
      })]
    }))
  });
});